import { render, staticRenderFns } from "./AddonItem.vue?vue&type=template&id=f2d5a318&"
import script from "./AddonItemVue.ts?vue&type=script&lang=ts&"
export * from "./AddonItemVue.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports